import React from 'react'
import Header from '../../Layout/Header'
import Footer from '../../Layout/Footer'
import Section1 from './Section1'
import Section2 from './Section2'
import Section3 from './Section3'
import Section4 from './Section4'
import Section5 from './Section5'

export default function Home() {
    return (
        <div className='bg-white min-h-screen'>
            <Header />
          <div>  <Section1 />  </div>
          <div id='about'>  <Section2 />  </div>
          <div>  <Section3 />  </div>
          <div id='features'>  <Section4 />  </div>
          <div id='support'>  <Section5 />  </div>
            <Footer />
        </div>
    )
}
